import {
    BookOutlined,
    UserOutlined,
    PlusSquareOutlined,
    UserAddOutlined,
    FolderOutlined,
  } from '@ant-design/icons';
  import { APP_PREFIX_PATH } from 'configs/AppConfig'
  import maestro from '../../menus/icons/maestro'
  import familia from '../../menus/icons/familia'
  import userextra from '../../menus/icons/userextra'  
  let AdminSecModuloUsuarios = [
    {
        key: 'Usuarios',
        path: `${APP_PREFIX_PATH}/admin/usuarios/list`,
        title: 'sidenav.admin.usuarios.usuarios',
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: 'Agregar Usuario',
            path: `${APP_PREFIX_PATH}/admin/usuarios/add`,
            title: 'sidenav.admin.usuarios.agregar',
            icon: UserAddOutlined,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'Agregar campos',
            path: `${APP_PREFIX_PATH}/admin/usuarios/campos`,
            title: 'sidenav.admin.usuarios.campos',
            icon: PlusSquareOutlined,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'Clientes',
            path: `${APP_PREFIX_PATH}/admin/usuarios/list/2`,
            title: 'sidenav.admin.usuarios.clientes',
            icon: maestro,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'Alumnos',
            path: `${APP_PREFIX_PATH}/admin/usuarios/list/1`,
            title: 'sidenav.admin.usuarios.alumnos',
            icon: UserOutlined,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'Padres',
            path: `${APP_PREFIX_PATH}/admin/usuarios/list/5`,
            title: 'sidenav.admin.usuarios.padres',
            icon: familia,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'AdminSeccion',
            path: `${APP_PREFIX_PATH}/admin/usuarios/list/4`,
            title: 'sidenav.admin.usuarios.administradoresSecciones',
            icon: familia,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'Otros',
            path: `${APP_PREFIX_PATH}/admin/usuarios/list/extra`,
            title: 'sidenav.admin.usuarios.extras',
            icon: userextra,
            breadcrumb: true,
            submenu: []
          },
          {
            key: 'documentos',
            path: `${APP_PREFIX_PATH}/admin/documentos`,
            title: 'sidenav.documentos.documentos',
            icon: FolderOutlined,
            breadcrumb: true,
            submenu: [
              {
                key: 'documentos-listar',
                path: `${APP_PREFIX_PATH}/admin/documentos/list`,
                title: 'sidenav.documentos.documentos',
                icon: BookOutlined,
                breadcrumb: true,
                submenu: []
              },
              {
                key: 'documentos-entregas',
                path: `${APP_PREFIX_PATH}/documentos/entregas`,
                title: 'sidenav.documentos.entregas',
                icon: BookOutlined,
                breadcrumb: true,
                submenu: []
              }
            ]
          }
        ]
    }
  ]

  export default AdminSecModuloUsuarios;
  